import ClearFileSizeExceedModal from './ClearFileSizeExceedModal';

export default ClearFileSizeExceedModal;
